import React, { FC, useState } from 'react';
import { Modal, Button, Checkbox } from 'tea-component';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import './index.scss';
import { gotoDashboardGame } from '@/pages/home/utils/utils';
import { setItemDashboardTips, getItemDashboardTips } from '@/pages/intelligence/utils/topchartsUtils';

interface JumpDashboardModalProps {
  visible: boolean,
  setModalVisible: (value: boolean) => void;
  downloadTitle?: string,
  dashboardGameCode?: string,
}

const JumpDashboardModal: FC<JumpDashboardModalProps> = (props) => {
  const { formatMessage, locale } = useIntlExtend();
  const {
    visible,
    setModalVisible,
    downloadTitle = formatMessage({ id: 'dbi_tip' }),
    dashboardGameCode = '',
  } = props;

  // console.log('DownloadSettingModal', props);

  // 是否勾选'不再显示'
  const [selectedNoAgain, setSelectedNoAgain] = useState(false);

  const handleCloseModal = () => {
    const dashboardTips = getItemDashboardTips();
    const { openTotal = 0 } = dashboardTips;

    // 若勾选了’不再提示',则设置false，后面不再弹窗
    if (selectedNoAgain) {
      setItemDashboardTips(false);
    } else {
      // 若未勾选不再提示，则记录加1，并更新日期
      setItemDashboardTips(true, openTotal + 1);
    }

    setModalVisible(false);
  };

  const handleGotoDashboard = () => {
    gotoDashboardGame(dashboardGameCode);
    handleCloseModal();
  };

  const handleStayIntelligence = () => {
    handleCloseModal();
  };

  return (
    <Modal
      visible={visible}
      onClose={handleCloseModal}
      className={'dbi-jumpdashboard-modal'}
      caption={
        <div className="download-head">
          <span>{downloadTitle}</span>
        </div>
      }
    >
      <Modal.Body>
        <div className='dbi-jumpdashboard-modal-body-div'>
          {formatMessage({ id: 'dbi_jumpdashboard_modal_tips' })}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={`dbi-jumpdashboard-modal-footer-div ${locale === 'en-US' ? 'dbi-jumpdashboard-btn' : 'dbi-jumpdashboard-cn'}`}>
          <Button
            type="primary"
            onClick={handleGotoDashboard}
          >
            {formatMessage({ id: 'dbi_goto_dashboard' })}
          </Button>
          <Button type="weak" onClick={handleStayIntelligence}>
            {formatMessage({ id: 'dbi_stay_intelligence' })}
          </Button>
        </div>
        <div className='dbi-jumpdashboard-modal-footer-checkbox'>
          <Checkbox
            value={selectedNoAgain}
            onChange={(value) => setSelectedNoAgain(value)}
          >
            {formatMessage({ id: 'dbi_no_prompt_again' })}
          </Checkbox>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default JumpDashboardModal;
